export default {
    general: {
        back:     'Back',
        next:     'Next',
        cancel:   'Cancel',
        from:     'from',
        night:    'per night',
        nights:   '{count} night | {count} nights',
        loading:  'Loading …',
        language: 'Language',
        theme:    'Appearance',
    },
    errors: {
        generic_error: 'Something went wrong. Please try again.',
        invalid_data:  'Those details are not right.',
        not_found:     'Not found.',
        offline:       'We cannot reach the hotel. Check your connection and try again.',
        no_house:      'This property is not accepting online bookings.',
        taken:         'Somebody has just booked that room. Please choose another one or another date.',
        too_many:      'Too many attempts. Please wait a moment and try again.',
        too_many_guests: 'That room does not sleep this many people.',
        booking_failed:  'The booking could not be made.',
        offer_gone:      'The offer is no longer valid. These are the house’s ordinary prices.',
    },
    step: {
        dates:   'Dates',
        rooms:   'Room',
        guest:   'Details',
        summary: 'Summary',
        done:    'Confirmed',
    },
    search: {
        title:          'Book a room',
        lead:           'Choose your dates and how many of you there are; we will show what is free and what it costs.',
        arrival:        'Arrival',
        departure:      'Departure',
        adults:         'Adults',
        children:       'Children',
        submit:         'Find rooms',
        stay_too_long:  'A stay can be at most {nights} nights.',
        departure_after: 'Departure must be after arrival.',
        arrival_past:   'Arrival cannot be in the past.',
    },
    package: {
        title: 'In the package',
        included: 'included',
        surcharges_total: 'Surcharges',
        kind_room_service: 'Room service',
        kind_dining: 'Meal',
        kind_facility: 'Facility',
        kind_parking: 'Parking',
        kind_service: 'Service',
        kind_product: 'Product',
        when_arrival: 'on arrival',
        when_each_night: 'every night',
        when_departure: 'on departure',
    },
    rooms: {
        component_gone: 'Part of the package is not available for these dates',
        component_gone_hint: 'Fully booked: {what}. Try other dates — the package itself still stands.',
        title:      'Available rooms',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'Nothing is free for those dates.',
        none_hint:  'Try other dates, or fewer people.',
        change:     'Change dates',
        choose:     'Choose',
        per_stay:   'for the whole stay',
        left:       '{count} room left | {count} rooms left',
        sleeps:     'Sleeps up to {count}',
        beds:       '{count} bed | {count} beds',
        photo_of:   'Photograph of {name}',
        offer_price: 'offer price (−{percent}%)',
        early_booking:       'Early booking −{percent}%',
        early_booking_saved: 'you save {amount}',
        offer_applied: 'The prices below are this offer, reduced by {percent}%.',
        offer_gone: 'The offer is no longer valid',
        offer_gone_hint: 'The house has withdrawn or changed it, so the prices below are the ordinary ones.',
    },
    board: {
        none:       'Room only',
        breakfast:  'With breakfast',
        half_board: 'Half board',
        full_board: 'Full board',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'Your details',
        lead:       'We will confirm the booking to this address.',
        first_name: 'First name',
        last_name:  'Last name',
        email:      'Email',
        phone:      'Telephone',
        notes:      'Message to the hotel',
        notes_hint: 'Optional — the hour you arrive, or anything you would like us to know.',
        required:   'This field is required.',
        email_bad:  'Please enter a valid email address.',
        submit:     'Continue to summary',
    },
    summary: {
        room_only: 'Accommodation',
        payment_optional: 'You can pay now by card, or on arrival at reception.',
        payment_deposit: 'A prepayment of {amount} ({percent}% of the total) confirms the stay — now or via the link in the e-mail. The remainder is settled on arrival.',
        payment_full: 'The full amount of {amount} confirms the stay — now or via the link in the e-mail.',
        title:     'Summary',
        lead:      'Check the details and confirm your booking.',
        stay:      'Stay',
        room:      'Room',
        offer:     'Offer',
        early_booking: 'Early booking',
        guests:    'Guests',
        contact:   'Contact',
        city_tax:  'City tax {amount} per person per night',
        total:     'Total incl. taxes',
        payment:   'Payment on arrival, at reception.',
        cancellation: 'Free cancellation until {date}',
        terms:     'Terms & conditions',
        accept:    'I agree to the booking terms and cancellation policy.',
        accept_required: 'The terms have to be accepted to book.',
        submit:    'Confirm booking',
        sending:   'Sending …',
    },
    done: {
        payment_optional: 'You can pay now by card, or on arrival at reception.',
        payment_remainder: 'The remaining {amount} is settled on arrival, at reception.',
        payment_required: 'Please pay {amount} to complete your stay',
        payment_required_hint: 'The room is booked and waiting for you. You can pay now, or from the link in your confirmation email.',
        payment_done: 'Payment received. Thank you!',
        pay_now: 'Pay {amount}',
        pay_later: 'The payment link is in your confirmation email as well.',
        pay_failed: 'The payment page could not be opened. Please try again, or use the link in your email.',
        title:      'Your booking is confirmed',
        number:     'Reservation number',
        keep:       'Keep the number — it is how we find you if you call.',
        mail_sent:  'We have sent the confirmation to {email}.',
        mail_none:  'We could not send the confirmation by email; the hotel will contact you.',
        payment:    'Payment on arrival, at reception.',
        again:      'Book again',
    },
    occupancy: {
        adults:   '{count} adult | {count} adults',
        children: '{count} child | {count} children',
    },
    license: {
        title: 'This service is not enabled',
        lead: 'This hotel has not enabled online booking, so a room cannot be reserved through this page.',
        contact: 'Please call the hotel’s front desk — they will be glad to make the booking for you.',
    },
    closed: {
        title: 'Bookings are not open',
        lead:  'This property is not booking online right now. Please call reception — they will be glad to help.',
    },
}
